// src/config/plans.js
// Configuracion centralizada de planes SaaS

export const PLANS = {
  free: {
    id: 'free',
    name: 'Free',
    description: 'Para equipos pequenos que quieren probar la plataforma',
    maxUsers: 5,
    modules: ['gestorPro', 'tareas', 'generador'], // Solo 3 modulos basicos
    allModules: false,
    price: 0,
    priceLabel: 'Gratis',
    color: 'gray',
    badge: 'bg-gray-100 text-gray-600',
    features: [
      'Hasta 5 usuarios',
      '3 modulos basicos',
      'Soporte por email',
    ],
  },
  pro: {
    id: 'pro',
    name: 'Pro',
    description: 'Para empresas en crecimiento que necesitan mas capacidad',
    maxUsers: 25,
    modules: ['gestorPro', 'tareas', 'generador', 'calendario', 'agenteIA', 'horasExtra', 'ventas'],
    allModules: true,
    price: 49,
    priceLabel: '$49/mes',
    color: 'indigo',
    badge: 'bg-indigo-100 text-indigo-700',
    features: [
      'Hasta 25 usuarios',
      'Todos los modulos',
      'Soporte prioritario',
      'Reportes avanzados',
    ],
  },
  enterprise: {
    id: 'enterprise',
    name: 'Enterprise',
    description: 'Para organizaciones grandes con necesidades avanzadas',
    maxUsers: Infinity,
    modules: ['gestorPro', 'tareas', 'generador', 'calendario', 'agenteIA', 'horasExtra', 'ventas'],
    allModules: true,
    price: 149,
    priceLabel: '$149/mes',
    color: 'purple',
    badge: 'bg-purple-100 text-purple-700',
    features: [
      'Usuarios ilimitados',
      'Todos los modulos',
      'Soporte dedicado 24/7',
      'Reportes avanzados',
      'API access',
      'SLA garantizado',
    ],
  },
};

export const PLAN_ORDER = ['free', 'pro', 'enterprise'];

/**
 * Obtener config de un plan
 */
export const getPlanConfig = (planId) => {
  return PLANS[planId] || PLANS.free;
};

/**
 * Verificar si un modulo esta incluido en un plan
 */
export const isModuleInPlan = (planId, moduleKey) => {
  const plan = getPlanConfig(planId);
  return plan.modules.includes(moduleKey);
};

/**
 * Verificar si se puede agregar mas usuarios
 */
export const canAddUser = (planId, currentUserCount) => {
  const plan = getPlanConfig(planId);
  return currentUserCount < plan.maxUsers;
};

/**
 * Obtener cuantos usuarios quedan disponibles
 */
export const getRemainingUsers = (planId, currentUserCount) => {
  const plan = getPlanConfig(planId);
  if (plan.maxUsers === Infinity) return Infinity;
  return Math.max(0, plan.maxUsers - currentUserCount);
};

/**
 * Todos los modulos disponibles con metadata
 */
export const ALL_MODULES = [
  { key: 'gestorPro', label: 'Gestor Pro', icon: '📋', description: 'Base de conocimiento' },
  { key: 'generador', label: 'Generador', icon: '📝', description: 'Mensajes para cursos' },
  { key: 'tareas', label: 'Tareas', icon: '✅', description: 'Gestion de tareas' },
  { key: 'calendario', label: 'Calendario', icon: '📅', description: 'Calendario academico' },
  { key: 'agenteIA', label: 'Agente IA', icon: '🤖', description: 'Asistente IA' },
  { key: 'horasExtra', label: 'Horas Extra', icon: '⏱️', description: 'Asistencia y horas' },
  { key: 'ventas', label: 'Ventas', icon: '💰', description: 'Ventas y comisiones' },
];
